import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import constants from '../../../lib/constants'
import { Link } from 'react-router'

class StatsView extends React.Component {
  static propTypes = {
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
    loadJobsForDevice: PropTypes.func,
    params: PropTypes.shape({})
  }

  static defaultProps = {
    jobs: [],
    loadJobsForDevice: _.noop,
    params: {}
  }

  constructor (props) {
    super(props)
    this.state = {
      numDays: 7
    }
  }

  componentDidMount () {
    const { loadJobsForDevice, params } = this.props
    loadJobsForDevice(params.device_string)
  }

  updateNumDays = (e) => {
    this.setState({
      numDays: parseInt(e.target.value)
    })
  }

  render () {
    const { numDays } = this.state
    const { jobs, params } = this.props
    const { pathname } = this.props.location

    const sortedJobs = _.sortBy(jobs, (j) => -new Date(j.created_at))
    const finishedJobs = _.filter(sortedJobs, (job) => job.job_status === constants.JOB_STATUSES.COMPLETED || job.job_status === constants.JOB_STATUSES.FAILED)

    const jobsToAnalyze = _.filter(finishedJobs, (j) => {
      const lastWeekDate = new Date()
      lastWeekDate.setDate(lastWeekDate.getDate() - numDays)
      return new Date(j.created_at) > lastWeekDate
    })

    let errorRate = null
    let flagRate = null
    let times = []
    let failRate = 0

    let numErrors = 0
    let numFlags = 0
    let numFails = 0

    _.forEach(jobsToAnalyze, (job) => {
      if (job.error_message) {
        numErrors += 1
      }
      if (job.flag) {
        numFlags += 1
      }
      if (job.job_status === constants.JOB_STATUSES.FAILED) {
        numFails += 1
      }
      const timeDiff = new Date(job.updated_at) - new Date(job.created_at)
      if (timeDiff < 15 * 60 * 1000) {
        times.push(timeDiff)
      }
    })

    errorRate = numErrors / jobsToAnalyze.length
    flagRate = numFlags / jobsToAnalyze.length
    failRate = numFails / jobsToAnalyze.length
    const averageTime = times.length > 0 ? _.mean(times) : null
    return (
      <div>
        <ul className='nav nav-tabs' style={{ marginBottom: 20 }}>
        <li className='nav-item'>
          <Link className={`nav-link ${pathname.indexOf('stats') === -1 ? 'active' : ''}`} to={`/device/${params.device_string}/`}>
            Results
          </Link>
        </li>
        <li className='nav-item'>
          <Link className={`nav-link ${pathname.indexOf('stats') > -1 ? 'active' : ''}`} to={`/device/${params.device_string}/stats`}>
            Stats
          </Link>
        </li>
      </ul>
        <div className='table-responsive'>
          <table className='table'>
            <thead className='thead-dark'>
              <tr>
                <th scope='col'>Time Span</th>
                <th scope='col'>Error Rate</th>
                <th scope='col'>Flag Rate</th>
                <th scope='col'>Fail Rate</th>
                <th scope='col'>Average Time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type='number'
                    id='days'
                    min='1'
                    value={numDays}
                    onChange={this.updateNumDays}
                    style={{ marginRight: 5, width: 60 }}
                  />
                  days
                </td>
                <td>{(errorRate * 100).toFixed(2)}%</td>
                <td>{(flagRate * 100).toFixed(2)}%</td>
                <td>{(failRate * 100).toFixed(2)}%</td>
                <td>{Number(averageTime / 1000).toFixed(2)} seconds</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default StatsView



// WEBPACK FOOTER //
// ./src/routes/Stats/components/StatsView.js